import styled, { css } from 'styled-components';

const StyledSwitchDot = styled.span<{ $checked: boolean }>`
	display: block;
	position: relative;
	width: 12px;
	height: 12px;
	border-radius: 50%;
	transition:
		margin 0.3s ease,
		background-color 0.3s ease;

	${({ $checked }) =>
		$checked
			? css`
					margin-left: calc(100% - 12px);
					background-color: #fff;
			  `
			: css`
					margin-left: 0;
					background-color: #bbb;
			  `}
`;

const StyledSwitch = styled.div`
	position: relative;
	width: 40px;
	height: 20px;
	padding: 4px;
	background-color: rgba(50, 50, 50, 1);
	border-radius: 4px;
	cursor: pointer;
`;

const StyledText = styled.span`
	display: flex;
	align-items: center;
	font-family: 'GT Walsheim Pro';
	font-size: 12px;
	color: #ffffff;
`;

export { StyledSwitch, StyledSwitchDot, StyledText };
